(() => {
  const init = root => {
    if (root.dataset.playpenReady) return;
    root.dataset.playpenReady = 'true';
    const stockPreview = root.querySelector('[data-playpen-preview-stock]');
    if (stockPreview && window.Shopify?.designMode) {
      const refreshMs = 10 * 60 * 1000;
      const storageKey = 'mirthly-stock-preview:' + stockPreview.dataset.stockPreviewKey;
      let savedStock;
      try { savedStock = JSON.parse(sessionStorage.getItem(storageKey)); } catch {}
      const refreshStockPreview = () => {
        if (!root.isConnected) return;
        const now = Date.now();
        if (!savedStock || !Number.isInteger(savedStock.count) || savedStock.count < 1 || savedStock.count > 30 || !Number.isFinite(savedStock.refreshAt) || savedStock.refreshAt <= now || savedStock.refreshAt > now + refreshMs) {
          const previousCount = savedStock?.count;
          let count = Math.floor(Math.random() * 30) + 1;
          if (count === previousCount) count = count % 30 + 1;
          savedStock = { count, refreshAt: now + refreshMs };
          try { sessionStorage.setItem(storageKey, JSON.stringify(savedStock)); } catch {}
        }
        stockPreview.querySelector('[data-preview-stock-count]').textContent = String(savedStock.count);
        stockPreview.dataset.refreshAt = String(savedStock.refreshAt);
        window.setTimeout(refreshStockPreview, Math.max(1, savedStock.refreshAt - Date.now()));
      };
      refreshStockPreview();
    }
    const catVideos = Array.from(root.querySelectorAll('.mpp-videos video'));
    const manuallyPausedVideos = new WeakSet();
    const playVisibleVideo = video => {
      if (document.hidden || video.dataset.playpenVisible !== 'true' || manuallyPausedVideos.has(video)) return;
      const playback = video.play();
      if (playback) playback.catch(() => {});
    };
    catVideos.forEach(video => {
      video.controls = false;
      video.muted = true;
      video.playsInline = true;
      video.tabIndex = 0;
      video.setAttribute('role', 'button');
      const togglePlayback = () => {
        if (video.paused) video.play().catch(() => {});
        else video.pause();
      };
      video.addEventListener('click', togglePlayback);
      video.addEventListener('keydown', event => {
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          togglePlayback();
        }
      });
      video.addEventListener('pause', () => {
        if (video.dataset.playpenVisible === 'true' && !document.hidden) manuallyPausedVideos.add(video);
      });
      video.addEventListener('play', () => manuallyPausedVideos.delete(video));
    });
    if ('IntersectionObserver' in window && catVideos.length) {
      const videoObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const video = entry.target;
          const visible = entry.isIntersecting && entry.intersectionRatio >= 0.2;
          video.dataset.playpenVisible = String(visible);
          if (visible) playVisibleVideo(video);
          else video.pause();
        });
      }, { threshold: [0, 0.2] });
      catVideos.forEach(video => videoObserver.observe(video));
      document.addEventListener('visibilitychange', () => {
        catVideos.forEach(video => {
          if (document.hidden) video.pause();
          else playVisibleVideo(video);
        });
      });
    }
    const form = root.querySelector('form');
    const atc = root.querySelector('[data-playpen-add]');
    const label = root.querySelector('[data-playpen-add-label]');
    const sticky = root.querySelector('.mpp-sticky');
    const stickyAdd = root.querySelector('[data-playpen-sticky-add]');
    const stickyLabel = root.querySelector('[data-playpen-sticky-label]');
    const stickySelect = root.querySelector('[data-playpen-sticky-select]');
    const variantInput = root.querySelector('[data-playpen-variant]');
    let submitting = false;
    let added = false;
    const purchaseButtons = [atc, stickyAdd];
    purchaseButtons.forEach(button => {
      button.addEventListener('pointerdown', () => {
        if (button.disabled) return;
        button.animate([{transform:'scale(1)'},{transform:'scale(.96)'},{transform:'scale(1)'}], {duration:280,easing:'ease-out'});
      });
    });
    const syncAvailability = available => {
      atc.disabled = submitting || !available;
      stickyAdd.disabled = atc.disabled;
      label.textContent = added ? '✓ ADDED TO CART' : submitting ? 'ADDING…' : available ? 'ADD TO CART' : 'SOLD OUT';
      stickyLabel.textContent = label.textContent;
      purchaseButtons.forEach(button => {
        button.classList.toggle('mpp-is-loading', submitting && !added);
        button.classList.toggle('mpp-is-added', added);
        button.setAttribute('aria-busy', String(submitting));
      });
    };
    const choose = button => {
      if (submitting) return;
      added = false;
      const pack = button.closest('[data-playpen-pack]');
      root.querySelectorAll('[data-playpen-pack]').forEach(item => {
        const active = item === pack;
        item.classList.toggle('is-selected', active);
        item.querySelector('[data-playpen-bundle]').setAttribute('aria-pressed', String(active));
        item.querySelector('.mpp-colors').hidden = !active;
        item.querySelector('.mpp-warranty').hidden = !active;
        item.querySelectorAll('select').forEach(select => select.disabled = !active);
      });
      variantInput.value = button.dataset.variant;
      stickySelect.value = button.dataset.variant;
      root.querySelector('[data-playpen-sticky-price]').textContent = button.dataset.price;
      syncAvailability(button.dataset.available === 'true');
      requestAnimationFrame(syncSticky);
      const url = new URL(location.href); url.searchParams.set('variant', button.dataset.variant); history.replaceState(null, '', url);
    };
    root.querySelectorAll('[data-playpen-bundle]').forEach(button => button.addEventListener('click', () => choose(button)));
    stickySelect.addEventListener('change', () => {
      const button = Array.from(root.querySelectorAll('[data-playpen-bundle]')).find(item => item.dataset.variant === stickySelect.value);
      if (button) choose(button);
    });
    stickyAdd.addEventListener('click', () => form.requestSubmit());
    const main = root.querySelector('.mpp-main-image');
    root.querySelectorAll('[data-playpen-color]').forEach(select => select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const image = select.closest('.mpp-color-control').querySelector('img');
      image.src = option.dataset.photo; image.removeAttribute('srcset'); image.alt = select.value + ' playpen';
      main.src = option.dataset.fullPhoto; main.removeAttribute('srcset'); main.alt = select.value + ' outdoor pet playpen';
      const stickyImage = root.querySelector('.mpp-sticky-image');
      stickyImage.src = option.dataset.photo; stickyImage.removeAttribute('srcset'); stickyImage.alt = image.alt;
      main.animate([{opacity:.4},{opacity:1}], {duration:220,easing:'ease-out'});
    }));
    root.querySelectorAll('[data-playpen-image]').forEach(button => button.addEventListener('click', () => {
      main.src = button.dataset.playpenImage; main.removeAttribute('srcset'); main.alt = button.dataset.alt;
      root.querySelectorAll('[data-playpen-image]').forEach(item => item.classList.toggle('is-active', item === button));
    }));
    const dialog = root.querySelector('dialog');
    root.querySelector('[data-playpen-open]').addEventListener('click', () => { dialog.querySelector('img').src = main.src; dialog.showModal(); });
    root.querySelector('[data-playpen-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    const syncSticky = () => {
      const rect = atc.getBoundingClientRect();
      const mainVisible = rect.top < innerHeight - 24 && rect.bottom > 0;
      const titlePassed = root.querySelector('h1').getBoundingClientRect().top < 0;
      sticky.hidden = !titlePassed || mainVisible;
    };
    window.addEventListener('scroll', syncSticky, { passive:true }); window.addEventListener('resize', syncSticky); syncSticky();
    if ('ResizeObserver' in window) new ResizeObserver(syncSticky).observe(form);
    form.addEventListener('submit', async event => {
      event.preventDefault(); if (atc.disabled || submitting) return;
      const selected = root.querySelector('[data-playpen-bundle][aria-pressed="true"]');
      const status = root.querySelector('[data-playpen-status]'); status.textContent = '';
      submitting = true; syncAvailability(true);
      try {
        const properties = {};
        if (selected.dataset.count === '4') { properties['Bundle offer'] = 'Buy 3, Get 1 Free — 4 playpens total'; }
        form.querySelectorAll('.mpp-colors select:not(:disabled)').forEach(select => { properties[select.name.slice(11,-1)] = select.value; });
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer?.getSectionsToRender().map(section => section.id) || [];
        const base = window.Shopify?.routes?.root || '/';
        const items = [{id:Number(variantInput.value),quantity:1,properties}];
        const protection = form.querySelector('[data-package-protection]');
        if (protection?.checked) items.push({id:Number(protection.dataset.variantId),quantity:1});
        const response = await fetch(base + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items,sections,sections_url:location.pathname}) });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || 'Unable to add to cart. Please try again.');
        added = true; syncAvailability(true);
        status.textContent = 'Added to your cart.';
        await new Promise(resolve => setTimeout(resolve, 450));
        if (drawer && payload.sections) { drawer.renderContents(payload); drawer.classList.remove('is-empty'); } else { location.assign(base + 'cart'); }
        setTimeout(() => { added = false; syncAvailability(selected.dataset.available === 'true'); }, 2200);
      } catch (error) { status.textContent = error.message; }
      finally { submitting = false; syncAvailability(selected.dataset.available === 'true'); }
    });
  };
  document.querySelectorAll('[data-playpen-section]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-playpen-section]').forEach(init));
})();
